// [row, column] on a 12-column grid, approximating US geography for the
// admin dashboard's tile map. Rows are 1-indexed top to bottom.
export const STATE_GRID = {
  AK: [1, 1],  ME: [1, 12],
  WA: [2, 1],  ID: [2, 2],  MT: [2, 3],  ND: [2, 4],  MN: [2, 5],  IL: [2, 6],
  WI: [2, 7],  MI: [2, 8],  NY: [2, 9],  RI: [2, 10], VT: [2, 11], NH: [2, 12],
  OR: [3, 1],  NV: [3, 2],  WY: [3, 3],  SD: [3, 4],  IA: [3, 5],  IN: [3, 6],
  OH: [3, 7],  PA: [3, 8],  NJ: [3, 9],  CT: [3, 10], MA: [3, 11],
  CA: [4, 1],  UT: [4, 2],  CO: [4, 3],  NE: [4, 4],  MO: [4, 5],  KY: [4, 6],
  WV: [4, 7],  VA: [4, 8],  MD: [4, 9],  DE: [4, 10],
  AZ: [5, 2],  NM: [5, 3],  KS: [5, 4],  AR: [5, 5],  TN: [5, 6],  NC: [5, 7],
  SC: [5, 8],  DC: [5, 9],
  OK: [6, 4],  LA: [6, 5],  MS: [6, 6],  AL: [6, 7],  GA: [6, 8],
  HI: [7, 1],  TX: [7, 4],  FL: [7, 9],
};

// Canadian provinces and territories, drawn in two rows ABOVE the US tiles on the same 12 columns,
// roughly over the states they border (BC over WA, ON over the Great Lakes, the Maritimes over New
// England). Same [row, column] convention; the map adds CA_ROWS to every US row.
export const PROVINCE_GRID = {
  YT: [1, 1],  NT: [1, 2],  NU: [1, 3],  NL: [1, 11],
  BC: [2, 1],  AB: [2, 2],  SK: [2, 3],  MB: [2, 4],  ON: [2, 6],  QC: [2, 9],
  NB: [2, 10], PE: [2, 11], NS: [2, 12],
};
export const CA_ROWS = 3; // two province rows plus an empty spacer row
